export const elevatorNumber = {
  className: 'cls-9',
  d: 'm354.293,122.7539c0-2.1318,1.2744-3.6406,3.3545-4.5244l-.0264-.0781c-1.8721-.8838-2.6777-2.3398-2.6777-3.7959,0-2.6777,2.2617-4.498,5.2256-4.498,3.2764,0,4.915,2.0537,4.915,4.1602,0,1.4297-.7021,2.9639-2.7822,3.9521v.0781c2.1055.832,3.4053,2.3135,3.4053,4.3682,0,2.9375-2.5215,4.9141-5.7461,4.9141-3.5361,0-5.668-2.1064-5.668-4.5762Zm9.1006-.1045c0-2.0537-1.4307-3.042-3.7178-3.6914-1.9766.5713-3.043,1.8721-3.043,3.4834-.0781,1.7168,1.2227,3.2246,3.3809,3.2246,2.0537,0,3.3799-1.2744,3.3799-3.0166Zm-6.292-8.4502c0,1.6904,1.2734,2.6006,3.2236,3.1201,1.4561-.4941,2.5742-1.5342,2.5742-3.0684,0-1.3516-.8057-2.7559-2.8604-2.7559-1.8975,0-2.9375,1.248-2.9375,2.7041Z',
}

export const FLOOR_8_DATA = [
  {
    id: 'C054-1',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'C054-1',
    sceneName: 'scene_08krs_C054-1',
    sceneName_future: 'scene_08krs_C054-1_future',
    name: 'C054-1',
    label: 'C54-1',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-17',
      points:
        '140.4167 39.9271 140.4167 65.4167 240 65.4167 240 43.4938 216.5003 43.4703 216.5003 36.4583 194.2083 36.4583 194.2083 39.9271 140.4167 39.9271',
    },
    viewCone: {
      className: 'cls-7',
      pathData:
        'm159.6999,56.9679c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '157.0223',
      cy: '52.5213',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: 'm198.0039,55.0391c-.459.2236-1.0605.334-1.8008.334-.9668,0-1.7275-.2832-2.2812-.8516s-.8301-1.3262-.8301-2.2725c0-1.0078.3105-1.8252.9336-2.4521.6221-.627,1.4297-.9404,2.4238-.9404.6152,0,1.1328.0781,1.5547.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0684.1865-1.4316.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5137,1.4561.3428.3623.8047.543,1.3848.543.5527,0,1.0605-.1348,1.5195-.4043v1.2959Z',
      },
      {
        className: 'cls-13',
        d: 'm199.1035,55.1016v-1.1875c.4297.2637.8887.3965,1.375.3965.3662,0,.6523-.0879.8594-.2617.207-.1748.3096-.4111.3096-.71,0-.624-.4404-.9365-1.3232-.9365-.2871,0-.6338.0273-1.041.0801v-3.5205h3.4893v1.1338h-2.3027v1.2617c.1846-.0176.3584-.0273.5225-.0273.6484,0,1.1543.1709,1.5215.5098.3652.3408.5488.7979.5488,1.3711,0,.6367-.2188,1.1553-.6543,1.5586-.4375.4023-1.0293.6035-1.7754.6035-.6074,0-1.1172-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-13',
        d: 'm208.498,53.9238h-.7559v1.3398h-1.2656v-1.3398h-2.7461v-.8838l2.6455-4.0781h1.3662v3.9727h.7559v.9893Zm-2.0039-3.5732h-.0254c-.041.1055-.1211.2695-.2383.4922l-1.3486,2.0918h1.5947v-1.9814c0-.1758.0059-.377.0176-.6025Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'B012',
      5: 'A016',
      6: 'B024-1',
      7: 'B026',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C054-2',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'C054-2',
    sceneName: 'scene_08krs_C054-2',
    sceneName_future: 'scene_08krs_C054-2_future',
    name: 'C054-2',
    label: 'C54-2',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-17',
      points:
        '194.4167 65.4167 240 65.4167 240.7722 73.9349 194.4167 73.9349 194.4167 65.4167',
    },
    viewCone: {
      className: 'cls-2',
      pathData:
        'm219.4194,74.3845c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '216.7418',
      cy: '69.938',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: '',
      },
      {
        className: 'cls-13',
        d: '',
      },
      {
        className: 'cls-13',
        d: '',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C030',
      4: 'C035',
      5: 'C040',
      6: 'C045',
      7: 'C050',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C055',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'C055',
    sceneName: 'scene_08krs_C055',
    sceneName_future: 'scene_08krs_C055_future',
    name: 'C055',
    label: 'C55',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-17',
      points:
        '229.6667 14.4226 229.6667 28.7778 222.3333 28.7778 222.3333 36.4583 194.2083 36.4583 194.2083 39.9271 140.4167 39.9271 140.4167 14.4375 229.6667 14.4226',
    },
    viewCone: {
      className: 'cls-15',
      pathData:
        'm160.6721,30.7801c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '157.9945',
      cy: '26.3335',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: 'm198.0039,28.915c-.4609.2236-1.0605.334-1.8027.334-.9668,0-1.7266-.2832-2.2793-.8516-.5547-.5684-.832-1.3262-.832-2.2725,0-1.0078.3125-1.8252.9336-2.4521.623-.627,1.4316-.9404,2.4238-.9404.6152,0,1.1348.0781,1.5566.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0703.1865-1.4336.5586s-.5449.876-.5449,1.5117c0,.6094.1719,1.0947.5156,1.4561.3418.3623.8027.543,1.3828.543.5547,0,1.0605-.1348,1.5215-.4043v1.2959Z',
      },
      {
        className: 'cls-13',
        d: 'm199.1016,28.9775v-1.1875c.4316.2637.8887.3965,1.375.3965.3672,0,.6543-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3223-.9365-.2871,0-.6348.0273-1.043.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3594-.0273.5234-.0273.6465,0,1.1543.1709,1.5195.5098.3672.3408.5488.7979.5488,1.3711,0,.6367-.2168,1.1553-.6543,1.5586-.4355.4023-1.0273.6035-1.7754.6035-.6055,0-1.1152-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-13',
        d: 'm204.2793,28.9775v-1.1875c.4297.2637.8887.3965,1.375.3965.3652,0,.6523-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3242-.9365-.2871,0-.6348.0273-1.041.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3574-.0273.5215-.0273.6484,0,1.1543.1709,1.5215.5098.3652.3408.5488.7979.5488,1.3711,0,.6367-.2188,1.1553-.6543,1.5586-.4375.4023-1.0293.6035-1.7754.6035-.6074,0-1.1172-.0908-1.5293-.2715Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'A012',
      5: 'A016',
      6: 'B024-1',
      7: 'B026',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C053',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'C053',
    sceneName: 'scene_08krs_C053',
    sceneName_future: 'scene_08krs_C053_future',
    name: 'C053',
    label: 'C53',
    lookAt: '55.21, 0, 120',
    face: 'east',
    area: {
      className: 'cls-17',
      points:
        '272.7292 14.4226 277.3632 65.2781 240 65.4167 240 14.4254 272.7292 14.4226',
    },
    viewCone: {
      className: 'cls-1',
      pathData:
        'm274.1223,32.7301c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '271.4447',
      cy: '28.2835',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: 'm253.1934,49.2266c-.4609.2236-1.0605.334-1.8027.334-.9668,0-1.7266-.2832-2.2793-.8516-.5547-.5684-.832-1.3262-.832-2.2725,0-1.0078.3125-1.8252.9336-2.4521.623-.627,1.4316-.9404,2.4238-.9404.6152,0,1.1348.0781,1.5566.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0703.1865-1.4336.5586s-.5449.876-.5449,1.5117c0,.6094.1719,1.0947.5156,1.4561.3418.3623.8027.543,1.3828.543.5547,0,1.0605-.1348,1.5215-.4043v1.2959Z',
      },
      {
        className: 'cls-13',
        d: 'm254.291,49.2891v-1.1875c.4316.2637.8887.3965,1.375.3965.3672,0,.6543-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3223-.9365-.2871,0-.6348.0273-1.043.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3594-.0273.5234-.0273.6465,0,1.1543.1709,1.5195.5098.3672.3408.5488.7979.5488,1.3711,0,.6367-.2168,1.1553-.6543,1.5586-.4355.4023-1.0273.6035-1.7754.6035-.6055,0-1.1152-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-13',
        d: 'm259.3945,49.2441v-1.208c.4219.3076.9141.4619,1.4766.4619.3535,0,.6289-.0762.8281-.2285.1973-.1523.2969-.3652.2969-.6377,0-.2812-.123-.498-.3672-.6504-.2461-.1523-.582-.2285-1.0098-.2285h-.5664v-1.0635h.5234c.8203,0,1.2305-.2725,1.2305-.8174,0-.5127-.3164-.7686-.9453-.7686-.4219,0-.832.1357-1.2305.4082v-1.1338c.4414-.2227.959-.334,1.5469-.334.6445,0,1.1465.1455,1.5059.4346.3574.291.5371.667.5371,1.1299,0,.8232-.416,1.3389-1.252,1.5469v.0225c.4453.0557.7969.2168,1.0547.4854.2578.2676.3867.5967.3867.9863,0,.5889-.2148,1.0547-.6465,1.3975-.4297.3428-1.0254.5137-1.7832.5137-.6504,0-1.1797-.1055-1.5859-.3164Z',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C028',
      4: 'C033',
      5: 'C038',
      6: 'C043',
      7: 'C048',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'D076',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'D076',
    sceneName: 'scene_08krs_D076',
    sceneName_future: 'scene_08krs_D076_future',
    name: 'D076',
    label: 'D76',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-17',
      points:
        '240 65.4167 277.3632 65.2781 279.9633 93.8129 234.0051 97.8329 231.9167 74 240.7722 73.9349 240 65.4167',
    },
    viewCone: {
      className: 'cls-11',
      pathData:
        'm240.3152,90.3523c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '237.5015',
      cy: '86.0801',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: 'm250.9072,83v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-13',
        d: 'm261.6299,77.3398l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
      {
        className: 'cls-13',
        d: 'm266.4287,76.7637v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
    ],

    relatedApartments: {
      2: 'D059',
      3: 'D061',
      4: 'D064',
      5: 'D067',
      6: 'D070',
      7: 'D073',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
  {
    id: 'D077-1',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'D077-1',
    sceneName: 'scene_08krs_D077-1',
    sceneName_future: 'scene_08krs_D077-1_future',
    name: 'D077-1',
    label: 'D77-1',
    lookAt: '-215.35, 0, 120',
    face: 'south',
    area: {
      className: 'cls-17',
      points:
        '242.8685 97.0576 257.7612 95.7549 258.7778 106.6111 265.6965 105.9661 266.4444 113.0556 281.6169 111.9601 286.008 160.1507 248.875 163.3125 243.9768 109.2825 242.8685 97.0576',
    },
    viewCone: {
      className: 'cls-12',
      pathData:
        'm268.783,148.8075c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '266.1054',
      cy: '144.3609',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: 'm251.7324,124.624v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-13',
        d: 'm262.4551,118.9639l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
      {
        className: 'cls-13',
        d: 'm267.6318,118.9639l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
    ],

    relatedApartments: {
      2: 'D060',
      3: 'D062',
      4: 'D065',
      5: 'D068',
      6: 'D071',
      7: 'D074',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'D077-2',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'D077-2',
    sceneName: 'scene_08krs_D077-2',
    sceneName_future: 'scene_08krs_D077-2_future',
    name: 'D077-2',
    label: 'D77-2',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-17',
      points: '',
    },
    viewCone: {
      className: 'cls-11',
      pathData:
        'm242.1791,110.5267c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '239.5015',
      cy: '103.0801',
      circleClassName: 'cls-9',
    },
    namePaths: [
      {
        className: 'cls-13',
        d: '',
      },
      {
        className: 'cls-13',
        d: '',
      },
      {
        className: 'cls-13',
        d: '',
      },
    ],

    relatedApartments: {
      2: 'D059',
      3: 'D063',
      4: 'D066',
      5: 'D069',
      6: 'D072',
      7: 'D075',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
]
